export interface ParsedGoogleStreetViewUrl {
  lat: number;
  lng: number;
  heading: number | null;
  pitch: number | null;
  fov: number | null;
}

/**
 * 解析貼上的 Google 街景網址，格式為
 * .../@{lat},{lng},{zoom}a,{fov}y,{heading}h,{tilt}t/...
 * lat/lng 是必要資訊（沒有就丟出錯誤）；heading/fov/pitch 是可選的相機參數，
 * 網址裡沒有就回傳 null（代表未知，不是 0——跟後端 nullable 欄位的設計一致）。
 *
 * pitch 是由 tilt 換算來的（pitch = tilt - 90，Google 街景網址裡 tilt=90 代表水平視角），
 * 這個換算公式是跟 autoplus 正式站既有 gas_stations 資料表裡的值逐筆比對確認過的，
 * 不是近似值。
 */
export function parseGoogleStreetViewUrl(
  url: string,
): ParsedGoogleStreetViewUrl {
  if (!url.includes('@')) {
    throw new Error('街景網址格式錯誤');
  }

  const segment = url.split('@')[1].split('/')[0];
  const parts = segment.split(',');

  const lat = parseFloat(parts[0]);
  const lng = parseFloat(parts[1]);
  if (!lat || !lng) {
    throw new Error('請確保街景網址中有提供經緯度資訊');
  }

  let heading: number | null = null;
  let pitch: number | null = null;
  let fov: number | null = null;

  for (const part of parts.slice(2)) {
    const value = parseFloat(part);
    if (Number.isNaN(value)) continue;

    if (part.endsWith('h')) {
      heading = value;
    } else if (part.endsWith('y')) {
      fov = value;
    } else if (part.endsWith('t')) {
      pitch = value - 90;
    }
  }

  return { lat, lng, heading, pitch, fov };
}
